var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "10e085d7-d85d-4576-93ae-c42847af53d5"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "e12ce788-0634-4529-ac4f-b85472807a96"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -20.15 -363.45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3968.16, -5727.17)",
    d: "M 3850 5801 C 3850 5796 3824 5783 3793 5773 C 3737 5756 3735 5754 3732 5718 C 3728 5672 3739 5666 3846 5650 C 3940 5636 4079 5649 4158 5678 C 4201 5694 4205 5698 4205 5730 C 4205 5760 4201 5765 4170 5773 C 4151 5778 4128 5788 4119 5796 C 4107 5806 4072 5810 3977 5810 C 3905 5810 3850 5806 3850 5801 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 28.12 -9.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4330.23, -3074.96)",
    d: "M 4800 5679 C 4735 5661 4718 5614 4759 5566 C 4768 5556 4805 5528 4843 5504 C 4880 5480 4910 5456 4910 5452 C 4910 5447 4902 5432 4892 5419 C 4882 5406 4859 5370 4842 5339 C 4824 5307 4803 5280 4795 5276 C 4787 5273 4748 5278 4708 5286 C 4627 5304 4479 5301 4399 5280 C 4355 5269 4350 5270 4269 5310 C 4160 5364 4041 5405 3906 5436 C 3835 5452 3777 5472 3741 5494 C 3710 5512 3671 5531 3653 5538 C 3568 5567 3387 5561 3248 5525 C 3124 5493 2998 5413 2951 5336 C 2925 5294 2923 5223 2947 5205 C 2965 5192 2968 5199 2882 5050 C 2868 5025 2838 4951 2815 4885 C 2782 4785 2771 4763 2750 4755 C 2736 4750 2671 4718 2605 4685 C 2509 4637 2472 4612 2416 4558 L 2348 4490 L 2281 4500 C 2245 4505 2167 4514 2108 4521 C 2010 4532 2001 4534 1997 4555 C 1995 4568 1997 4586 2003 4595 C 2008 4604 2009 4636 2005 4666 C 2000 4708 1993 4724 1972 4741 C 1920 4782 1759 4751 1651 4678 C 1537 4600 1428 4445 1414 4340 C 1409 4299 1411 4291 1437 4263 C 1509 4186 1640 4216 1829 4353 C 1907 4411 1916 4414 1964 4412 C 2035 4410 2233 4379 2246 4368 C 2255 4362 2253 4337 2239 4273 C 2229 4225 2220 4172 2220 4156 C 2220 4116 2252 3990 2262 3990 C 2287 3990 2260 3948 2182 3867 C 2053 3733 2001 3666 1913 3523 C 1845 3412 1827 3391 1771 3351 C 1644 3261 1574 3183 1524 3077 C 1432 2878 1464 2612 1596 2488 C 1663 2425 1819 2383 1917 2401 C 1941 2406 1990 2421 2027 2436 C 2102 2466 2089 2467 2276 2416 C 2388 2386 2603 2360 2747 2360 C 2806 2360 2860 2356 2866 2352 C 2872 2348 2880 2331 2883 2314 C 2903 2208 3010 2052 3115 1974 C 3166 1937 3190 1913 3190 1899 C 3190 1887 3167 1824 3139 1757 C 3111 1691 3073 1593 3053 1541 C 3034 1488 3012 1429 3005 1410 L 2992 1375 L 2883 1364 C 2696 1346 2595 1282 2526 1137 C 2478 1039 2464 935 2485 844 C 2527 662 2639 537 2810 481 C 2885 456 2942 455 3028 475 C 3183 512 3287 602 3340 747 C 3371 833 3366 976 3328 1067 C 3297 1144 3222 1247 3193 1255 C 3149 1266 3157 1298 3301 1652 C 3322 1705 3344 1766 3348 1787 L 3356 1825 L 3510 1826 C 3692 1826 3763 1839 3878 1892 C 3924 1913 3967 1930 3972 1930 C 3978 1930 4017 1897 4059 1857 C 4207 1716 4392 1577 4520 1511 C 4664 1437 4693 1413 4727 1346 C 4767 1267 4888 1149 4973 1106 C 5174 1004 5437 1049 5604 1213 C 5671 1279 5721 1364 5761 1481 C 5780 1537 5782 1559 5777 1655 C 5774 1716 5765 1786 5757 1812 C 5743 1857 5743 1864 5765 1927 C 5818 2081 5850 2316 5850 2553 L 5850 2729 L 5893 2741 C 5981 2765 6066 2825 6123 2906 C 6145 2936 6172 2963 6185 2966 C 6203 2970 6241 2955 6327 2909 C 6392 2875 6481 2828 6524 2805 C 6568 2782 6610 2754 6616 2744 C 6623 2734 6636 2691 6644 2650 C 6676 2496 6729 2401 6824 2330 C 6926 2253 7006 2240 7098 2286 C 7161 2318 7191 2355 7225 2443 C 7292 2623 7212 2867 7044 2991 C 6981 3038 6906 3054 6826 3039 C 6772 3029 6707 2983 6688 2942 C 6673 2911 6628 2901 6602 2923 C 6592 2931 6509 2979 6415 3031 C 6322 3082 6242 3129 6237 3135 C 6233 3140 6231 3155 6233 3167 C 6235 3179 6233 3236 6229 3293 C 6221 3387 6216 3410 6174 3504 L 6128 3610 L 6176 3666 C 6298 3805 6362 3909 6394 4022 C 6407 4069 6419 4087 6461 4122 C 6523 4175 6560 4235 6560 4284 C 6560 4341 6522 4439 6474 4507 C 6404 4605 6310 4683 6183 4747 C 6073 4803 6068 4804 5963 4811 C 5872 4817 5835 4825 5725 4863 C 5616 4901 5428 4947 5267 4976 C 5240 4980 5225 4990 5215 5009 C 5187 5063 5038 5186 4975 5207 C 4934 5221 4938 5241 5001 5339 L 5052 5420 L 5154 5420 C 5217 5420 5276 5426 5308 5435 C 5357 5450 5360 5453 5360 5483 C 5359 5520 5341 5544 5285 5582 C 5166 5662 4919 5711 4800 5679 z M 4014 5320 C 4085 5292 4161 5260 4182 5249 L 4222 5229 L 4162 5167 C 4087 5088 4070 5055 4063 4969 C 4060 4931 4052 4896 4045 4890 C 4039 4885 3973 4865 3899 4845 C 3743 4804 3553 4741 3458 4699 C 3422 4683 3381 4670 3369 4670 C 3356 4670 3320 4686 3288 4705 C 3206 4756 3135 4778 3025 4786 C 2973 4790 2930 4797 2930 4803 C 2930 4826 2974 4961 3007 5038 L 3043 5121 L 3109 5113 C 3218 5100 3378 5105 3450 5124 C 3548 5150 3689 5221 3737 5268 C 3761 5291 3786 5326 3795 5346 C 3809 5381 3812 5382 3848 5377 C 3868 5373 3943 5348 4014 5320 z M 5430 4851 C 5573 4824 5741 4783 5753 4771 C 5759 4765 5757 4747 5746 4721 C 5737 4698 5727 4656 5724 4628 C 5703 4446 5932 4196 6193 4114 L 6251 4096 L 6245 4060 C 6230 3979 6062 3760 6014 3760 C 6002 3760 5970 3778 5944 3800 C 5853 3875 5711 3936 5570 3960 C 5498 3973 5470 3985 5470 4003 C 5470 4018 5345 4248 5294 4327 C 5223 4437 5177 4505 5155 4530 C 5114 4577 5116 4587 5179 4657 C 5236 4719 5270 4785 5270 4835 C 5270 4877 5280 4878 5430 4851 z M 4149 4749 C 4181 4705 4284 4632 4368 4593 C 4514 4525 4657 4503 4854 4519 C 4920 4524 4979 4526 4986 4523 C 5019 4511 5299 4052 5316 3982 C 5323 3958 5306 3930 5285 3930 C 5267 3930 5161 3872 5119 3839 C 5069 3799 4997 3688 4969 3605 C 4927 3480 4943 3283 5006 3162 C 5013 3149 5016 3132 5014 3126 C 5006 3105 4661 2962 4407 2875 C 4352 2856 4302 2836 4294 2829 C 4272 2811 4254 2825 4219 2890 C 4174 2975 4062 3092 3981 3140 C 3815 3238 3616 3270 3420 3228 C 3390 3222 3356 3211 3346 3204 C 3326 3191 3300 3201 3300 3221 C 3300 3226 3269 3298 3231 3382 C 3171 3515 3050 3829 3050 3851 C 3050 3855 3089 3884 3137 3916 C 3332 4043 3450 4223 3450 4395 C 3450 4440 3444 4485 3435 4507 C 3427 4526 3420 4544 3420 4547 C 3420 4562 3745 4684 3950 4746 C 4090 4788 4120 4789 4149 4749 z M 2597 3783 C 2670 3771 2701 3770 2777 3780 C 2828 3786 2874 3789 2879 3786 C 2884 3782 2892 3765 2896 3747 C 2908 3690 3017 3409 3085 3261 C 3121 3182 3150 3113 3150 3106 C 3150 3100 3129 3078 3104 3058 C 2987 2963 2879 2764 2855 2598 L 2848 2551 L 2796 2545 C 2745 2539 2506 2558 2358 2581 C 2285 2592 2280 2594 2280 2617 C 2280 2630 2298 2673 2320 2713 C 2372 2808 2390 2883 2390 3000 C 2390 3113 2373 3181 2324 3261 C 2270 3350 2179 3408 2078 3417 C 2036 3421 2020 3427 2020 3437 C 2020 3476 2179 3690 2296 3807 L 2358 3870 L 2433 3834 C 2480 3812 2542 3793 2597 3783 z M 5193 2912 C 5311 2805 5409 2754 5565 2719 L 5672 2696 L 5668 2460 C 5664 2277 5659 2215 5647 2180 C 5638 2155 5630 2120 5630 2102 C 5630 2056 5607 2052 5565 2088 C 5519 2129 5458 2164 5385 2191 C 5298 2224 5122 2224 5035 2190 C 4848 2118 4724 1973 4660 1755 C 4630 1651 4632 1652 4564 1702 C 4378 1839 4323 1883 4242 1955 C 4124 2060 4122 2066 4166 2129 C 4258 2264 4291 2361 4299 2524 C 4304 2615 4309 2645 4320 2651 C 4328 2655 4400 2680 4480 2705 C 4607 2747 4952 2881 5080 2938 C 5105 2949 5128 2959 5132 2959 C 5136 2960 5164 2938 5193 2912 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 6.8 -122.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4170.36, -3919.31)",
    d: "M 4010 4267 C 3882 4224 3782 4128 3750 4019 C 3718 3913 3724 3865 3782 3755 C 3826 3671 3899 3617 4023 3575 C 4114 3545 4238 3540 4306 3563 C 4507 3635 4610 3753 4610 3915 C 4610 4076 4540 4169 4351 4260 C 4295 4288 4281 4290 4182 4290 C 4098 4290 4061 4285 4010 4267 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -219.79 -303.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2470.88, -5274.37)",
    d: "M 2500 5396 C 2379 5354 2284 5293 2250 5237 C 2176 5116 2338 5095 2539 5200 C 2648 5257 2710 5313 2710 5353 C 2710 5405 2698 5414 2628 5416 C 2583 5418 2546 5412 2500 5396 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 260.68 -277.15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6074.4, -5079.93)",
    d: "M 5860 5220 C 5826 5186 5835 5154 5894 5092 C 6012 4968 6241 4880 6293 4938 C 6328 4977 6303 5041 6227 5102 C 6086 5217 5913 5273 5860 5220 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 365.04 -130.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6857.09, -3977.8)",
    d: "M 6827 4002 C 6809 3982 6804 3945 6818 3936 C 6823 3933 6833 3942 6840 3955 C 6847 3969 6866 3985 6881 3992 C 6896 3999 6906 4008 6904 4012 C 6895 4027 6843 4020 6827 4002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 384.13 -96.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7000.31, -3728.27)",
    d: "M 6816 3892 C 6810 3867 6814 3850 6834 3815 C 6856 3778 6867 3770 6898 3765 C 6976 3752 6980 3750 6980 3726 C 6980 3713 6973 3686 6965 3667 C 6943 3615 6957 3588 7018 3562 C 7068 3540 7135 3533 7156 3548 C 7174 3561 7192 3619 7186 3645 C 7180 3667 7175 3670 7131 3670 C 7073 3670 7066 3677 7016 3782 C 6978 3862 6961 3876 6908 3871 C 6867 3867 6840 3879 6831 3903 C 6823 3923 6822 3922 6816 3892 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -387.3 -57.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1214.57, -3432.39)",
    d: "M 1243 3689 C 1159 3657 1089 3585 1036 3476 C 996 3395 990 3374 990 3320 C 990 3210 1031 3161 1128 3157 C 1192 3155 1242 3181 1316 3255 C 1398 3338 1432 3410 1438 3515 C 1444 3622 1427 3663 1368 3690 C 1315 3714 1308 3714 1243 3689 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -324.41 172.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1686.24, -1710.85)",
    d: "M 1572 2024 C 1512 1994 1471 1949 1432 1870 C 1408 1821 1405 1804 1405 1710 C 1405 1611 1407 1600 1437 1539 C 1478 1456 1526 1407 1586 1386 C 1743 1333 1896 1428 1951 1614 C 1976 1699 1973 1766 1939 1855 C 1911 1930 1823 2023 1764 2039 C 1697 2058 1629 2053 1572 2024 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 302.92 211.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6391.26, -1415.94)",
    d: "M 6295 1736 C 6204 1693 6138 1601 6105 1472 C 6091 1418 6091 1405 6104 1346 C 6125 1258 6160 1192 6209 1147 C 6263 1098 6303 1079 6365 1073 C 6408 1068 6428 1072 6473 1093 C 6616 1158 6699 1294 6687 1444 C 6680 1535 6659 1593 6612 1654 C 6536 1755 6406 1789 6295 1736 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 44.14 328.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,34,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4450.37, -535.02)",
    d: "M 4349 866 C 4242 835 4168 770 4118 663 C 4056 530 4075 416 4178 308 C 4298 182 4427 160 4585 238 C 4676 283 4736 343 4780 434 C 4824 524 4826 541 4806 615 C 4776 725 4714 797 4604 851 C 4546 879 4419 886 4349 866 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57f64913720606d8682d98e7bdb1a1db.svg";
export { ForwardRef as ReactComponent };